// eslint-disable-next-line eqeqeq
export const isEmpty = (value: string) => value === undefined || value.length === 0;
